export const getProcessIdFromSearch = (search: string): number | undefined => {
  const rawId: string | null = new URLSearchParams(search).get('processId')
  if (!rawId || !/^[1-9]\d*$/.test(rawId)) return undefined
  const processId: number = Number.parseInt(rawId, 10)
  return Number.isSafeInteger(processId) ? processId : undefined
}
